import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { color } from "../Utils/Constant";
import { fetchUserData } from "../Utils/api";
import whatsapp from "../Assets/Contact_icons/whatsapp.png";
import snapchat from "../Assets/Contact_icons/snapchat.png";
import email from "../Assets/Contact_icons/email.png";
import telephone from "../Assets/Contact_icons/phone.png";
import Address from "../Assets/Contact_icons/address.png";
import Website from "../Assets/Contact_icons/website.png";
import skype from "../Assets/Contact_icons/skype.png";
import facebook from "../Assets/Contact_icons/facebook.png";
import instagram from "../Assets/Contact_icons/instagram.png";
import linkedin from "../Assets/Contact_icons/linkedin.png";
import twitter from "../Assets/Contact_icons/twitter.png";
import tiktok from "../Assets/Contact_icons/tiktok.png";

// styles
const MainContainer = styled.div`
  padding: 10px;
  gap: 25px;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
`;
const LinkButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px;
  width: 100%;
  align-items: flex-start;
  word-break: break-word;
  overflow: hidden;
  &:hover {
    background-color: ${color.linkHover};
  }
`;

const LinkIconContainer = styled.div`
  color: ${(props) => props.color || color.black};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LinkIcon = styled.img`
  width: 27px;
  height: 27px;
  object-fit: contain;
  border-radius: 50%;
`;
const LinkName = styled.p`
  font-size: 12px;
  color: ${color.gray};
`;

const LinkIconMainContainer = styled.div`
  width: 11%;
`;

const LinkDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  flex: 1;
  word-break: break-word;
  overflow: hidden;
  min-width: 0;
  gap: 7px;
`;

const LinkDetails = styled.p`
  font-size: 13px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
`;
const openWhatsApp = (phoneNumber) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const message = encodeURIComponent("Hello, I have a question!"); // Optional: You can pre-fill a message

  if (isMobile) {
    // Try to open WhatsApp app
    window.location.href = `whatsapp://send?phone=${phoneNumber}&text=${message}`;
    
    // Fallback to WhatsApp Web if the app is not installed
    setTimeout(() => {
      if (!document.hidden) {
        window.location.href = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
      }
    }, 2000); // Wait 2 seconds to see if the app opens
  } else {
    // Directly open WhatsApp Web on desktop
    window.location.href = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
  }
};
const Contact = ({ userName }) => {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchUserData(userName);
        setdata(result[0]);
      } catch (error) {
        console.log("error fetching data in contact", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [userName]);

  if (loading)
    return <p style={{ textAlign: "center", padding: "10px" }}>Loading...</p>;
  return (
    <MainContainer>
      {/* mobile  */}
      {data.mobile ? (
        <LinkButtonContainer
        onClick={() => openWhatsApp(data.mobile)}
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={whatsapp} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Whatsapp</LinkName>
            <LinkDetails>{data.mobile}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>
      ) : (
        ""
      )}
      {/* email */}
      {data.email ? (
        <LinkButtonContainer
          onClick={() => (window.location.href = `mailto:${data.email}`)}
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={email} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Email</LinkName>
            <LinkDetails>{data.email}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>
      ) : (
        ""
      )}

      {/* telephone */}
      {data.telephone ? (
        <LinkButtonContainer
          onClick={() => (window.location.href = `tel:${data.telephone}`)}
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={telephone} />
            </LinkIconContainer>
          </LinkIconMainContainer>

          <LinkDetailsContainer>
            <LinkName>Telephone</LinkName>
            <LinkDetails>{data.telephone}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>
      ) : (
        ""
      )}

      {/* address */}
      {data.address ? (
        <LinkButtonContainer
          onClick={() =>
            window.open(
              `https://www.google.com/maps/search/?q=${encodeURIComponent(
                data.address
              )}`,
              "_blank"
            )
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={Address} />
            </LinkIconContainer>
          </LinkIconMainContainer>

          <LinkDetailsContainer>
            <LinkName>Communication Address</LinkName>
            <LinkDetails>{data.address}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>
      ) : (
        ""
      )}
      {/* website */}
      {data.website ? (
        <LinkButtonContainer
          onClick={() => window.open(data.website, "_blank")}
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={Website} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Website</LinkName>
            <LinkDetails>{data.website}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>
      ) : (
        ""
      )}

      {/* skype */}
      {
        data.skype ? (<LinkButtonContainer
          onClick={() => window.open(`skype:${data.skype}`, "_blank")}
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={skype} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Skype</LinkName>
            <LinkDetails>{data.skype}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
      
      {/* facebook */}
      {
        data.facebook ? (<LinkButtonContainer
          onClick={() =>
            window.open(`${data.facebook}`, "_blank")
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={facebook} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Facebook</LinkName>
            <LinkDetails>{data.facebook}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
      
      {/* instagram */}
      {
        data.instagram ? (<LinkButtonContainer
          onClick={() =>
            window.open(`${data.instagram}`, "_blank")
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={instagram} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Instagram</LinkName>
            <LinkDetails>{data.instagram}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
      {/* linkedin */}
      {
        data.linkedin ? (<LinkButtonContainer
          onClick={() =>
            window.open(`${data.linkedin}`, "_blank")
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={linkedin} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Linkedin</LinkName>
            <LinkDetails>{data.linkedin}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
      {/* twitter */}
      {
        data.twitter ? (<LinkButtonContainer
          onClick={() =>
            window.open(`${data.twitter}`, "_blank")
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={twitter} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Twitter</LinkName>
            <LinkDetails>{data.twitter}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
      {/* twitter */}
      {
        data.snapchat ? (<LinkButtonContainer
          onClick={() =>
            window.open(`${data.snapchat}`, "_blank")
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={snapchat} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Snapchat</LinkName>
            <LinkDetails>{data.snapchat}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
       {/* tiktok */}
      {
        data.tiktok ? (<LinkButtonContainer
          onClick={() =>
            window.open(`${data.tiktok}`, "_blank")
          }
        >
          <LinkIconMainContainer>
            <LinkIconContainer>
              <LinkIcon src={tiktok} />
            </LinkIconContainer>
          </LinkIconMainContainer>
          <LinkDetailsContainer>
            <LinkName>Tiktok</LinkName>
            <LinkDetails>{data.tiktok}</LinkDetails>
          </LinkDetailsContainer>
        </LinkButtonContainer>):''
      }
      
    </MainContainer>
  );
};

export default Contact;
